import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Chart, ChartConfiguration, ChartType } from 'chart.js';
import { Router } from '@angular/router';
import {Color, Label} from 'ng2-charts/ng2-charts';
import { ChartDataSets, ChartOptions } from 'chart.js';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import Swal from 'sweetalert2';
import { ServiceService } from 'src/app/services/service.service';
import { FormControl, FormControlName, FormGroup } from '@angular/forms';
declare var iziToast: any;




@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.css']
})


export class AnalyticsComponent implements OnInit {
  gaugeChart: any;

 users:number=500

  
  values=[
    {
      'id':'1234567890',
       'name':'Natarajan',
       'status':'Active',
         'statuss':'Inactive',
          'statusse':'500mb',
            "expired":'21/03/2025'
    },
    {
      'id':'01234567891',
       'name':'jeevanths',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'200mb',
         "expired":'11/03/2025'
    },
    {
      'id':'11122233300',
       'name':'manimuthu',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'100MB',
         "expired":'24/03/2025'
    },
    {
      'id':'29384935811',
       'name':'sarin',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'100MB',
         "expired":'1/05/2025'
    },
    {
      'id':'11111232424',
       'name':'dakshesh',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'200MB',
         "expired":'21/03/2025'
    },
    {
      'id':'11111334355',
       'name':'kam',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'300MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'vasantray kumar',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'700MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'sathya kumar',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'200MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'muthuraj kumar',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'100MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'pandyam kumar',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'300MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'udhyam kumar',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'200MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'vasantray kumar',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'200MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'Givinghswami',
       'status':'Active',
       'statuss':'Inactive',
       'statusse':'200MB',
       "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'Pandiyan raj',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'800MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'Muthu veluu',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'900MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'Somanray',
       'status':'Active',
         'statuss':'Inactive',
         'statusse':'400MB',
         "expired":'21/03/2025'
    },
    {
      'id':'111112440940',
       'name':'vasantray '
       ,'status':'Active',
         'statuss':'Inactive',
         'statusse':'500MB',
         "expired":'21/03/2025'
    }
    
  ]
  parentModalRef: any;
  v: any;
  stored: any;
  barChartData: { labels: any; datasets: { data: any; label: string; backgroundColor: string; borderColor: string; borderWidth: number; }[]; };
  valueFromAPI: number=0;
  value: any;
  uservalue:any;
  plans: any;
  dates: any;
  addusers: FormGroup;
  jsondata: Object;
  closeResult: string;


  
  constructor(private router:Router,private modalService: NgbModal,private serviceService: ServiceService) { }

  ngOnInit(): void {
   
    this.test();
    this.serviceService.getChartData().subscribe((res) => {
       console.log("😎API DATA:",res);
       if (res && res.length > 0) {
     
        this.barChartLabelsw = res.map(item => item.day);
        console.log("✅Single:", this.barChartLabelsw);
    
        this.barChartDataw[0].data= res.map(item => item.usageGB);
        console.log("✅ Double:", this.barChartDataw[0].data);
      }
    });
    this.valueFromAPI=40;
   this. userdateget();
   this.userdata();
    
   this.addusers=new FormGroup(
    {
      'user_id':new FormControl,
      'user_name':new FormControl
    }
   )
   this.jsonfiledate();
    }
   
  


  
  renewal(){
    this.router.navigate(['/renewal']);
  }

  public lineChartColors: Color[] = [
    { // dark grey
      backgroundColor: 'rgba(247, 185, 36, 0.2)',
      borderColor: '#f7b924',
      borderCapStyle: 'round',
      borderDash: [],
      borderWidth: 4,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
      pointBorderColor: '#f7b924',
      pointBackgroundColor: '#fff',
      pointHoverBorderWidth: 4,
      pointRadius: 6,
      pointBorderWidth: 5,
      pointHoverRadius: 8,
      pointHitRadius: 10,
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#f7b924',
    },
  ];

  public lineChartColors2: Color[] = [
    { // dark grey
      backgroundColor: 'rgba(48, 177, 255, 0.2)',
      borderColor: '#30b1ff',
      borderCapStyle: 'round',
      borderDash: [],
      borderWidth: 4,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
      pointBorderColor: '#30b1ff',
      pointBackgroundColor: '#ffffff',
      pointHoverBorderWidth: 4,
      pointRadius: 6,
      pointBorderWidth: 5,
      pointHoverRadius: 8,
      pointHitRadius: 10,
      pointHoverBackgroundColor: '#ffffff',
      pointHoverBorderColor: '#30b1ff',
    },
  ];

  public lineChartColors3: Color[] = [
    { // dark grey
      backgroundColor: 'rgba(86, 196, 121, 0.2)',
      borderColor: '#56c479',
      borderCapStyle: 'round',
      borderDash: [],
      borderWidth: 4,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
      pointBorderColor: '#56c479',
      pointBackgroundColor: '#fff',
      pointHoverBorderWidth: 4,
      pointRadius: 6,
      pointBorderWidth: 5,
      pointHoverRadius: 8,
      pointHitRadius: 10,
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#56c479',
    },
  ];
  // !----!_--!


  public bandwidthChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: 
      [{ gridLines: { display: false }, ticks:{ fontSize: 14, fontColor: '#FFFFFF'}},],
      yAxes: [{
        ticks: { beginAtZero: true, callback: value => `${value}M`, fontSize: 14, fontColor: '#FFFFFF' },
        scaleLabel: { display: true, labelString: 'Bandwidth (bps)', fontSize: 14, fontColor: '#FFFFFF'}
      }]
    },
    legend: { display: true, position: 'bottom',labels:{ fontSize: 14, fontColor: '#FFFFFF'}}

  };

  public bandwidthChartLabels: Label[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'];
  public bandwidthChartType: ChartType='line';

  public bandwidthChartData = [
    { data: [1, 1.2, 1.1, 1.5, 1.3, 1.6, 1.4, 1.7], label: 'Up', borderColor: '#FFC107', backgroundColor: 'orange', fill: true, fontSize: 14, fontColor: '#FFFFFF' },
    { data: [5, 7, 6.5, 9, 8.5, 11, 10.5, 12], label: 'Down', borderColor: '#D32F2F', backgroundColor: 'white', fill: true , fontSize: 14, fontColor: '#FFFFFF',color:'#FFFFF'}
  ];
  // !----!----!

  public gaugeChartLabels = ['Usage'];
  public gaugeChartData = [15.76, 100 - 15.76]; // 15.76% and remaining part
  public gaugeChartType: ChartType = 'doughnut';

  public gaugeChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 80,  
    rotation: -Math.PI, 
    circumference: Math.PI,
    legend: { display: false },
    tooltips: { enabled: false }
  };

  public gaugeChartColors = [
    {
      backgroundColor: ['#4CAF50', '#333'],  // Green and dark background
      borderWidth: 0
    }
  ];
  // !-----!----!
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        ticks: { beginAtZero: true, callback: value => `${value} GB`, fontColor: '#FFFFFF', fontSize: 14 },
        scaleLabel: { display: true, labelString: 'Data Transfer', fontColor: '#FFFFFF', fontSize: 14 }
      }],
      xAxes: [{
        ticks: {
          fontColor: '#FFFFFF', 
          fontSize: 14
        }
      }],
    },
    legend: { display: false },
    title: {
      display: true,
      fontSize: 16,
    }
  };

  public barChartLabels: Label[] = ['Mar 06', 'Mar 07', 'Mar 08', 'Mar 09', 'Mar 10', 'Mar 11', 'Mar 12', 'Mar 13'];
  public barChartType: ChartType = 'bar';

  public barChartDatad = [
    { data: [50, 60, 55, 50, 100, 120, 105, 55], label: 'WAN Data', backgroundColor: ['white', 'orange', 'white', 'orange', 'white', 'orange', 'white', 'orange'] }
  ];

// !-----!----!

public labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August'];

public options = {
  layout: {
    padding: {
      left: 0,
      right: 8,
      top: 0,
      bottom: 0
    }
  },
  scales: {
    yAxes: [{
      ticks: {
        display: false,
        beginAtZero: true
      },
      gridLines: {
        display: false
      }
    }],
    xAxes: [{
      ticks: {
        display: false
      },
      gridLines: {
        display: false
      }
    }]
  },
  legend: {
    display: false
  },
  responsive: true,
  maintainAspectRatio: false
};

public barChartOptionse: ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    yAxes: [{
      ticks: { beginAtZero: true },
      scaleLabel: { display: true, labelString: 'Usage %' }
    }]
  },
  legend: { display: false }
};

public barChartLabelse: Label[] = ['0', '1', '2', '3'];
public barChartTypes: ChartType = 'bar';

public barChartDatas = [
  { 
    data: [2, 4, 2.5, 3.5], 
    label: 'Usage', 
    backgroundColor: ['purple', 'blue', 'green', 'yellow']
  }
];



public lineChartOptions: ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        id: 'y-axis-CPU',
        position: 'left',
        ticks: { beginAtZero: true, fontSize: 14, fontColor: '#FFFFFF'},
        scaleLabel: { display: true, labelString: 'CPU',fontSize: 14, fontColor: '#FFFFFF'}
      },
      {
        id: 'y-axis-Memory',
        position: 'right',
        ticks: { beginAtZero: true, max: 100, fontSize: 14, fontColor: '#FFFFFF' },
        scaleLabel: { display: true, labelString: 'Memory', fontSize: 14, fontColor: '#FFFFFF' }
      }
    ]
  },
  legend: { display: true, position: 'bottom',labels:{ fontSize: 14, fontColor: '#FFFFFF'}}
};

public lineChartLabels: Label[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
public lineChartType: ChartType = 'line';

public lineChartData: ChartDataSets[] = [
  {
    data: [5, 6, 7, 5, 6, 8, 7, 6, 5, 4],
    label: 'CPU',
    borderColor: 'yellow',
    backgroundColor: 'orange',
    fill: false,
    yAxisID:'y-axis-CPU'
  },
  {
    data: [8, 9, 8.5, 9, 10, 11, 10, 9, 8.5, 7],
    label: 'CPU-Core',
    borderColor: 'orange',
    backgroundColor: 'white',
    fill: false,
    yAxisID: 'y-axis-CPU'
  },
  {
    data: [20, 22, 21, 23, 24, 25, 24, 22, 20, 18],
    label: 'blue',
    borderColor: 'blue',
    backgroundColor: 'orange',
    fill: false,
    yAxisID: 'y-axis-Memory'
  }
];


public barChartOptionss: ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    yAxes: [{
      ticks: { beginAtZero: true, callback: value => `${value} GB`, fontSize: 14, fontColor: '#FFFFFF' },
      scaleLabel: { display: true, labelString: 'CPU Usages', fontSize: 14, fontColor: '#FFFFFF' }
    }],
    xAxes: [{
      ticks: {
        fontColor: '#FFFFFF', 
        fontSize: 14
      }
    }],
  },
  legend: { display: false },
  title: {
    display: true,
    fontSize: 16,
  }
};

public barChartLabelss: Label[] = ['Mar 06', 'Mar 07', 'Mar 08', 'Mar 12', 'Mar 13'];
public barChartTypess: ChartType = 'bar';

public barChartDatass = [
  { data: [50, 60, 55, 50, 100, 120, 105, 55], label: 'WAN Data', backgroundColor: ['orange', 'white', 'orange', 'white', 'orange', 'white', 'orange', 'white'] }
];


openLarge(content) {
 
  this.parentModalRef = this.modalService.open(content, {
    size: 'lg'
  });
}
openXLarge(content) {
 
  this.parentModalRef = this.modalService.open(content, {
    size: 'xl'
  });
}
openSmall(content) {
 
  this.parentModalRef = this.modalService.open(content, {
    size: 'sm-down'
  });
}



openChild(childContent) {
  if (this.parentModalRef)
     {
      console.log('value:',this.parentModalRef);
    this.parentModalRef.close(); 
  }

  this.modalService.open(childContent, {
    size: 'lg'
  });
}

// open(content) {
//   this.modalService.open(content).result.then((result) => {
//     this.closeResult = `Closed with: ${result}`;
//   }, (reason) => {
//     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
//   });
// }

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}



ngAfterViewInit() {
  this.createGaugeChart();
}



createGaugeChart() {
  const ctx = document.getElementById('gaugeChart') as HTMLCanvasElement;
  if (!ctx) return;

  this.gaugeChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      datasets: [{
        data: [10, 10], // Example values (Used bandwidth, Remaining)
        backgroundColor: ['orange', '#FFFFFF'],
        borderWidth: 0
      }]
    },
    options: {
      cutoutPercentage: 70,
      rotation: -Math.PI,
      circumference: Math.PI,
      responsive: true,
      animation: {
        onComplete: function () {
          const chartInstance = this.chart;
          const ctx = chartInstance.ctx;
          const chartArea = chartInstance.chartArea;
          const centerX = (chartArea.left + chartArea.right) / 2;
          const centerY = chartArea.bottom;

          const bandwidthValue = 10; // Example value (Modify for dynamic data)
          const maxBandwidth = 20;
          const angle = Math.PI * (1 - bandwidthValue / maxBandwidth); // Proper angle calculation

          ctx.save();
          ctx.translate(centerX, centerY);
          ctx.rotate(angle);

          // Needle settings
          ctx.beginPath();
          ctx.moveTo(0, -5);  // Needle bottom
          ctx.lineTo(-5, -90); // Needle left
          ctx.lineTo(5, -90);  // Needle right
          ctx.fillStyle = '#37474F'; // Needle color
          ctx.fill();
          ctx.restore();
        }
      }
    }
  });
}

// !----!----!

// public barChartOptionsw: ChartOptions = {
//   responsive: true,
//   scales: {
//     yAxes: [{
//       ticks: { fontSize: 10, fontColor: '#FFFFFF' }
//     }],
//     xAxes: [{
//       ticks: {
//         fontColor: '#FFFFFF', 
//         fontSize: 12
//       }
//     }],
//   },
//   legend: { display: true , labels:{fontColor:'#FFFFF',fontSize:14}}
  
// };
// public barChartLabelsw: Label[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
// public barChartTypew: ChartType = 'bar';
// public barChartLegend = true;

// public barChartDataw = [
//   { data: [24, 25, 26, 27, 28, 29, 30], label: 'Total weeks',backgroundColor:['orange','white','orange','white','orange','white','orange'],fontColor:'#FFFFF',fontSize:14},
// ];

//  public barChartOptionsw: ChartOptions = {
//     responsive: true,
//     scales: {
//       yAxes: [{ ticks: { fontSize: 10, fontColor: '#FFFFFF' } }],
//       xAxes: [{ ticks: { fontColor: '#FFFFFF', fontSize: 12 } }],
//     },
//     legend: { display: true, labels: { fontColor: '#FFFFFF', fontSize: 14 } }
//   };

  
  // public barChartTypew: ChartType = 'bar';
  // public barChartLegend = true;

  // public barChartDataw: any[] = [];


// !----!---!


public barChartOptionsm: ChartOptions = {
  responsive: true,
  scales: {
    yAxes: [{
      ticks: { fontSize: 10, fontColor: '#FFFFFF' },
      scaleLabel: { display: true, fontSize: 14, fontColor: '#FFFFFF' }
    }],
    xAxes: [{
      ticks: {
        fontColor: '#FFFFFF', 
        fontSize: 12,
        
      }
    }],
  },
  legend: { display: true , labels:{fontColor:'#FFFFF',fontSize:14}}
 
};
public barChartLabelsm: Label[] = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
public barChartTypem: ChartType = 'bar';
public barChartLegendm = true;

public barChartDatam = [
  { data: [120, 150, 180, 220, 260, 300, 340, 380, 420, 460, 500, 540],backgroundColor:['orange','white','orange','white','orange','white','orange','white','orange','white','orange','white'], label: 'Total Months',fontColor:'#FFFFF',fontSize:14 },
];

Deletes(event:Event)
{ 
  event.stopPropagation();
}
  
  D()
  {
    Swal.fire({
      title: 'Are you sure to Delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    });
  }

   // Chart configuration

  //  loadData() {
  //   this.serviceService.getdata().subscribe(
  //     (res: any) => {
  //       this.stored = res;
  //       console.log("API Response", res);
  //     },
  //     (error) => {
  //       console.error("Error fetching chart data:", error);
  //     }
  //   );
  // }

  // public barChartOptionsw: ChartConfiguration['options'] = {
  //   responsive: true,
  //   scales: {
  //     xAxes: [{
  //       ticks: {
  //         display: true,
          
  //         fontSize: 14
  //       },
  //     }],
  //     yAxes: [{
  //       ticks: {
  //         display: true,
  //         fontColor: '#FFFFFF', 
  //         fontSize: 14
  //       }
  //     }],
  //   },
  //   plugins: {
  //     legend: {
  //       labels: {
  //         color: '#FFFFFF'
  //       }
  //     }
  //   }
  // };

  // public barChartTypew: ChartType = 'bar';
  // public barChartDataw: ChartConfiguration['data'] = {
  //   labels: [],
  //   datasets: [{
  //     data: [],
  //     label: 'Predictions',
  //     backgroundColor: 'rgba(255, 255, 255, 0.7)',
  //     borderColor: 'rgba(255, 255, 255, 1)',
  //     borderWidth: 1
  //   }]
  // };


  test()
  {
    this.serviceService.getChartData().subscribe((res:any)=>
    {
      console.log("👍API Responces",res);
    });
  }

  public barChartLabelsw: string[] = [];
  public barChartDataw: any[] = [
    { data: [], label: 'Usage (GB)', backgroundColor:['orange','white','orange','white','orange','white','orange'],fontColor:'#FFFF',fontSize:
      14
     }
  ];
  public barChartOptionsw: any = {
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: 10,  
          fontSize: 14, 
          fontColor: '#FFFFFF'
        }
      }],
      xAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: 10,  
          fontSize: 14, 
          fontColor: '#FFFFFF'
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'top',
        color: '#fff',
        font: {
          weight: 'bold'
        },
        formatter: (value: number) => `${value} GB`
      }
    },
    legend: { display: true , labels:{fontColor:'white',fontSize:14 }}
  };
  public barChartTypew = 'bar';
  public barChartLegendw = true;
  public barChartPluginsw = [pluginDataLabels];
  


  userdata()
  {
     this.serviceService.getUserdata().subscribe((res:any)=>
    {
      if(res && res.data)
      {
      console.log("🙎Userresponce",res);
      this.uservalue=res.data;
      this.plans=res.data[0].plans
      console.log("✌️plans:",res.data[0].plans)
      }
      else
      {
        console.log("❌Data not found");
      }

    });
   
  }
  userdateget()
  {
    this.serviceService.getuserdates().subscribe((res:any)=>
    {
      console.log("✅Date",res);
      this.dates=res;
    })
  }
  save(data: any) {
    this.serviceService.getuserpostdata(data).subscribe(
      (res: any) => {
        if (res) {
            iziToast.success({
            title: 'Success',
            message: 'User data saved!',
            position: 'topRight'
          });
        }
      },
      (err) => {
        iziToast.error({
          title: 'Error',
          message: 'Failed to save user data.',
          position: 'topRight'
        });
      }
    );
  }

  jsonfiledate()
  {
    this.serviceService.getjsondata().subscribe((res)=>
    {
      this.jsondata=res;
    console.log("❌JSONFILE:",this.jsondata);
    });
  }

  }











